
// const urlPau  = urlPauMain( "panel" );
// const urlPauH = urlPauMain( "header" );

let multimediaPath = "multimedia/pau/react/";

const pictosPanel = urlPau => {

    urlPau += multimediaPath;

    return {

        perfiles    : {
            principal       : `${urlPau}panel/perfiles.png`,
            porDefecto      : `${urlPau}panel/perfiles/por-defecto.png`,
            visual          : `${urlPau}panel/perfiles/visual.png`,
            auditivo        : `${urlPau}panel/perfiles/auditivo.png`,
            cognitiva       : `${urlPau}panel/perfiles/cognitiva.png`,
            tipo            : `${urlPau}panel/perfiles/tipo.png`,
            personalizado   : `${urlPau}panel/perfiles/personalizado.png`
        },

        general     : {
            principal       : `${urlPau}panel/general.png`,
            todo            : `${urlPau}panel/general/todo.png`,
            sonido          : `${urlPau}panel/general/sonido.png`,
            video           : `${urlPau}panel/general/video.png`,
            lectura         : `${urlPau}panel/general/lectura.png`
        },

        navegacion  : {
            principal       : `${urlPau}panel/navegacion.png`,
            bigcursor       : `${urlPau}panel/navegacion/bigcursor.png`,
            nav             : `${urlPau}panel/navegacion/navegacion.png`,
            donde           : `${urlPau}panel/navegacion/donde.png`,
            zoom            : `${urlPau}panel/navegacion/zoom.png`
        },

        fuentes     : {
            principal       : `${urlPau}panel/fuentes.png`,
            tamanio         : `${urlPau}panel/fuentes/tamanio-fuentes.png`,
            legible         : `${urlPau}panel/fuentes/legible.png`,
            dislexia        : `${urlPau}panel/fuentes/dislexia.png`,
            enlaces         : `${urlPau}panel/fuentes/enlaces.png`
        },

        visual      : {
            principal       : `${urlPau}panel/visuales.png`,
            blancoNegro     : `${urlPau}panel/visuales/blanco-negro.png`,
            invertirColores : `${urlPau}panel/visuales/invertir-colores.png`
        },

        diseno      : {
            principal       : `${urlPau}panel/diseno.png`,
            plantilla       : `${urlPau}panel/diseno/plantillas.png`,
            posicion        : `${urlPau}panel/diseno/posicion.png`
        },

        ayuda      : {
            principal       : `${urlPau}panel/ayuda.png`,
            documentacion   : `${urlPau}panel/ayuda/documentacion.png`,
            video           : `${urlPau}panel/ayuda/video.png`,
            soporte         : `${urlPau}panel/ayuda/soporte.png`,
            sugerencias     : `${urlPau}panel/ayuda/sugerencias.png`
        }

    }

}

const pictosPanelHeader = urlPauH => {

    urlPauH += multimediaPath;

    return {
        icoPrin     : `${urlPauH}header/ico-principal-pau.svg`,
        icoSub      : `${urlPauH}header/ico-pau.svg`,
        mas         : `${urlPauH}header/pau-boton-mas.png`,
        menos       : `${urlPauH}header/pau-boton-menos.png`,
        reset       : `${urlPauH}header/resetear.png`
    }

}


export { pictosPanel, pictosPanelHeader };



// WEBPACK FOOTER //
// ./src/assets/img/panel/index.js